export default __webpack_public_path__ + "static/media/Pos2.9552838d.svg";